module.exports = {
      id: "menu_grid-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "assets/img/sprite-6589e8.svg#menu_grid-usage",
      toString: function () {
        return this.url;
      }
    }